<template>
    <div class="panel-body">
     <HeaderGeneral :vista="vista" :ruta="proveniente" :carpeta="carpeta" />
         <TableGeneral :optionst="options" :optionss="optionss" :fields="fields" :requiereListas="requiereListas" 
         :requiereDescarga="requiereDescarga" :requiereDescargaFormato="true" :condicionFiltrao="condicionFiltrao" :cliente="cliente" :editar="editable"
         :opcionRetirar="opcionRetirar" :opcionGestionar="opcionGestionar"  :requiereGestionar="requiereGestionar"
         :titulomodal="titulomodal" :botonmodal="botonmodal" :requiereBotongestionar="requiereBotongestionar" 
         :opcionRechazar="opcionRechazar" :condicionales="condicionales" :carpeta="carpeta" :opcionAsignar="opcionAsignar" 
         :typeOrder="typeOrder" :opcionRetiro="opcionRetiro" :rowClass="rowClass" :requierehistorialv="requierehistorialv"
         :requierecambiov="requierecambiov" :permisoRetiro="permisoRetiro" :permisoGestion="permisoGestion" 
         :permisoCambioValoracion="permisoCambioValoracion"
         :estadosPermitidosRetiro="[7, 16]"></TableGeneral>
     </div>
    
 </template>
 
 <script>
 import { RepositoryFactory } from "../../repositories/RepositoryFactory";
 import Vue from 'vue'
 import VueFormGenerator from 'vue-form-generator'
 import 'vue-form-generator/dist/vfg.css'
 import TableGeneral from "../../components/Table.vue";
 import HeaderGeneral from "../../components/HeaderGeneral.vue";
 import "vue-form-generator/dist/vfg-core.css";
 
 
 Vue.use(VueFormGenerator)
 
 const config = RepositoryFactory.get("config");
 const clientes = RepositoryFactory.get("clientes");
 export default {
     components: {
         "vue-form-generator": VueFormGenerator.component,
         TableGeneral,
         HeaderGeneral
     },
     data() {
         return {
            typeOrder: "desc",
            carpeta:"Prestadores",
             vista:"Dashboard de solicitudes",
             proveniente:" - Dashboard de solicitudes",
             requiereListas:true,
             requiereDescarga:true,
             condicionFiltrao:"en solicitud",
             editable:1,
             cliente:1,
             requiereGestionar:false,
             opcionAsignar:false,
             opcionRetirar:false,
             opcionRechazar:false,
             opcionGestionar:false,
             titulomodal:"Gestión y seguimiento",
             botonmodal:"Aceptar",
             requiereBotongestionar:"no",
             opcionRetiro:true,
             requierehistorialv:true,
             requierecambiov:true,
             permisoRetiro: true,
             permisoGestion: true,
             permisoCambioValoracion: true,
             options: [{ value: null, text: 'Seleccionar' }, { value: 'id', text: 'Número de solicitud' }, { value: 'documento', text: 'Documento' }, { value: 'nombre_completo', text: 'Paciente' }, { value: 'departamento', text: 'Departamento' },{ value: 'estado', text: 'Estado' }],
             
             departamentos: [{ value: null, text: 'Seleccionar' },],
            optionsclientes: [
                { value: null, text: 'Seleccionar' },
                { value: 1, text: 'cliente1' },
                { value: 2, text: 'clientes2' }
            ],
            optionsdos: [
                { value: null, text: 'Seleccionar' },
                { value: 'observaciones', text: 'Observación' },
                { value: 'estado', text: 'Estado' }
            ],
            optionss: [
            { value: null, text: 'Seleccionar' },
                { value: '1', text: 'Nuevo' },
                { value: '3', text: 'En solicitud' },
                { value: '5', text: 'Solicitud tomada' },
                { value: '6', text: 'Proceso de entrega' },
                  { value: '7', text: 'Entregado' },
                { value: '8', text: 'Fallo de entrega' },
                { value: '12', text: 'Segundo intento de entrega' },
                { value: '5', text: 'Solicitud retiro' },
                { value: '2', text: 'Rechazado' },
                { value: '10', text: 'Finalizado' },
                { value: '11', text: 'Cancelado' },


            ],
            optionm:[
            { value: null, text: 'Seleccionar' },
                { value: '1', text: 'Nuevo' },
                { value: '3', text: 'En solicitud' },
                { value: '5', text: 'Solicitud tomada' },
                { value: '6', text: 'Proceso de entrega' },
                  { value: '7', text: 'Entregado' },
                { value: '8', text: 'Fallo de entrega' },
                { value: '12', text: 'Segundo intento de entrega' },
                { value: '5', text: 'Solicitud retiro' },
                { value: '2', text: 'Rechazado' },
                { value: '10', text: 'Finalizado' },
                { value: '11', text: 'Cancelado' },
             ],
            endDate: "",
            fields: [
                { key: 'N°Solicitud', sortable: true },
                { key: 'Fecha solicitud', sortable: true },
                { key: 'T.Documento', sortable: true },
                { key: 'Documento', sortable: true },
                 { key: 'Paciente', sortable: true },
                 { key: 'Cliente', sortable: true },
                { key: 'Proveedor', sortable: true }, 
                //  { key: 'F.Valoración', sortable: true },
                 { key: 'F.Retiro oxígeno', sortable: true },
                 { key: 'Estado', sortable: true },
                    'Acciones'],
                   
            fieldsdos: ['Fecha', 'Estado', 'Observación'],
            condicionales: {
                "AND": [
                {
                        "estado": {
                            "notEquals": "0"
                        }
                    },
                    // {
                    //     "estado": {
                    //         "notEquals": "3"
                    //     }
                    // },
                    // {
                    //     "estado": {
                    //         "notEquals": "2"
                    //     }
                    // },
                    // {
                    //     "estado": {
                    //         "notEquals": "4"
                    //     }
                    // },
                    // {
                    //     "estado": {
                    //         "notEquals": "5"
                    //     }
                    // },
                    // {
                    //     "estado": {
                    //         "notEquals": "6"
                    //     }
                    // },
                    //  {
                    //     "estado": {
                    //         "notEquals": "12"
                    //     }
                    // },
                    // {
                    //     "estado": {
                    //         "notEquals": "8"
                    //     }
                    // },
                    // {
                    //     "estado": {
                    //         "notEquals": "10"
                    //     }
                    // },
                    // {
                    //     "estado": {
                    //         "notEquals": "11"
                    //     }
                    // },
                ]
            },
         }
 
     },
     computed: {
       
     },
     async created() {
        await this.validarPermisos();
     },
     methods: {
        async validarPermisos() {
            try {
                const datosUser = localStorage.getItem('user');
                if (datosUser) {
                    const usuario = JSON.parse(datosUser);
                    const idPerfil = usuario.id_perfil;
                    
                    // Perfiles de solo consulta: 5 (Asegurador) y 6 (Auditor)
                    if (idPerfil === 5 || idPerfil === 6) {
                        this.permisoRetiro = false;
                        this.permisoGestion = false;
                        this.permisoCambioValoracion = false;
                        this.opcionRetiro = false;
                        this.opcionGestionar = false;
                    } else {
                        // Opcional: Consultar API para validación adicional
                        try {
                            const response = await config.getPerfilPermisos({
                                id_perfil: idPerfil,
                                path_url: 'prestador-dashboard-solicitudes'
                            });
                            
                            // Si la API devuelve permisos específicos, usarlos
                            if (response && response.permisos) {
                                this.permisoRetiro = response.permisos.retiro !== false;
                                this.permisoGestion = response.permisos.gestion !== false;
                                this.permisoCambioValoracion = response.permisos.cambioValoracion !== false;
                            }
                        } catch (error) {
                            console.log('Error al validar permisos con API, usando permisos por defecto', error);
                        }
                    }
                }
            } catch (error) {
                console.error('Error al validar permisos:', error);
            }
        },
        rowClass(item, type) {
            console.log("prueba");
            
            // Si el estado es 13 (Retirado), no aplicar ningún color
            if (item.estado === 13) return '';
            
            // Obtener la fecha actual
            const fechaActual = new Date();

            // Fecha que quieres comparar (deberías obtenerla de tu fuente de datos, en este caso la estoy estableciendo manualmente)
            const fechaComparar = new Date(item['F.Retiro oxígeno']);

            // Calcular la diferencia en milisegundos
            const diferenciaEnMilisegundos = fechaComparar.getTime() - fechaActual.getTime();

            // Calcular la diferencia en días
            const diferenciaEnDias = Math.floor(diferenciaEnMilisegundos / (1000 * 60 * 60 * 24));

            if (!item || type !== 'row') return
            if (item['F.Retiro oxígeno'] == undefined || item['F.Retiro oxígeno'] == '' ) return ''
            if (item['F.Retiro oxígeno']<= fechaActual.toISOString().slice(0, 10)) return 'table-danger'
            if (diferenciaEnDias >= 10) return 'table-success'
            if (diferenciaEnDias >= 5) return 'table-warning'
            if (diferenciaEnDias < 5) return 'table-danger'
            // if (item['F.Retiro oxígeno']>=  item['F.Retiro oxígeno'].setDate(item['F.Retiro oxígeno'].getDate() + 5)) return 'table-warning'
            // if (item['F.Retiro oxígeno']>= item['F.Retiro oxígeno'].setDate(item['F.Retiro oxígeno'].getDate() + 15)) return 'table-success'
        },
     }
 };
 </script>
 <style>
 </style>
